import axios from "axios";
import client from "../client";

export async function postWhatsappUser() {
  const data = JSON.stringify({
    provider: "WHATSAPP",
  });

  return axios.post("https://api4.unipile.com:13415/api/v1/accounts", data, {
    headers: {
      "X-API-KEY": "tZ9uoJrH.h4LksyyI9JQdBwCNwJejVclGdoXCMM+XAFha0ZFaaII=",
      accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function getWhatsappConversations(talent: string) {
  return client.get(`${talent}/whatsapp-conversations`);
}

export function getConversationSummary(talent: string) {
  return client.post("conversations-summary", { talentId: talent });
}
